import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-repeat",
  "use": "foquz-icon-repeat-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" id=\"foquz-icon-repeat\"><path d=\"M11.108 9.781a4.95 4.95 0 01-8.891-1.118M1.008 10.99v-3M4 7.99H1m1.371-3.857a4.952 4.952 0 018.917.893m.739-3.017v3m-3.163 0h3\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol